var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1651",
    d: "M13.286 5.143h-2.571v7.5l1.285.643l1.286-.643zM6.858 9H4.286l.814 3.66a.43.43 0 0 0 .228.287l1.911.96a.86.86 0 0 1 .476.768v2.897l3 1.285v-3.642l-2.4-1.106a.86.86 0 0 1-.476-.6zm6.428 9.857v-3.642l2.4-1.106a.86.86 0 0 0 .476-.6L17.143 9h2.572l-.815 3.66a.43.43 0 0 1-.227.287l-1.911.96a.86.86 0 0 0-.476.768v2.897z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrime);
export default __webpack_public_path__ + "static/media/prime.9a2e63649feb89a92d12f7e3445a8a7e.svg";
export { ForwardRef as ReactComponent };